import React, {useState} from 'react'
import PropTypes from 'prop-types'
import style from './style.module.scss'

export const CircleButton = (props) => {

  function handleOnClick(){
    props.onCLick()
  }

  return (
    <div className={style.circleButton}>
        <div className={style.label}>{props.label}</div>
        <button onClick={handleOnClick} className={style.button}>
            {(props.icon)?props.icon:null}
        </button>
    </div>
  )
}
